import { getMeristemContext } from "@noom/meristem-context";

const defaultGeoLocation = {
  device_brand: "Apple",
  device_family: "Mac",
  device_is_mobile: false,
  device_os: "Mac OS X",
  city_name: "New York",
  continent_code: "NA",
  country_code: "US",
  is_eu_citizen: false,
  postal_code: "10001",
  subdivision: "NY",
  is_forced_country_code: false,
  language_code: "en",
  route_id: "_direct",
};

// This is a mocked response from the MaxMind database (CityResponse)
const defaultMaxmindDBResponse = {
  country: {
    iso_code: "US",
  },
  continent: {
    code: "NA",
  },
  city: {
    names: {
      en: "Queens",
    },
  },
  postal: {
    code: "11375",
  },
  subdivisions: [
    {
      geoname_id: 5128638,
      iso_code: "NY",
      names: {
        en: "New York",
      },
    },
  ],
};

/**
 * On staging/production this method will never be called since window.meristemContext will be used instead
 */
export default function getMeristemDefaultValue() {
  if (process.env.NODE_ENV === "development") {
    const userAgent = window?.navigator?.userAgent;
    const url = new URL(window.location);
    const response = getMeristemContext(
      url,
      userAgent,
      defaultMaxmindDBResponse,
      ""
    );

    if (response.redirectUrl) {
      return defaultGeoLocation;
    }

    return Object.assign({}, defaultGeoLocation, response);
  }
  return defaultGeoLocation;
}
